import {createAction} from '@ngrx/store';

import {RegionInfo} from '../models/region.model';

export const UpdateRegionInfo = createAction(
  '[Region] Update Region Info',
  (regionInfo: RegionInfo) => ({regionInfo})
);
